module.exports = __webpack_public_path__ + "static/media/test12_1.03468a8a.png";